import { format, parseISO } from 'date-fns';

export function formatDataHora(dataHora: string | undefined): string {
  if (!dataHora) return '—';
  try {
    return format(parseISO(dataHora), 'dd/MM/yyyy HH:mm:ss');
  } catch {
    return dataHora;
  }
}
